/*
 * @Author: Yolo
 * @Date: 2024-06-18 16:00:30
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-18 16:32:33
 * @Desc 航行警告绘制
 */

import L from 'leaflet'
import { center, featureCollection, point } from 'turf'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { DrawManager } from '@map-sdk/sdk/plugins/Draw/Draw'
import { NavigationalWarningServiceData } from '@map-sdk/sdk/plugins/NavigationalWarning/NavigationalWarningServiceData'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

export class NavigationalWarningService {
  private _map: MyMap
  private data: any
  private drawManager: DrawManager
  constructor(map: MyMap, options?: any) {
    this._map = map
    this.data = options?.data || NavigationalWarningServiceData.data
    this.drawManager = new DrawManager(this._map, {
      pmConfig: {
        position: 'topleft',
        drawMarker: false,
        drawCircleMarker: false,
        drawCircle: false,
        drawPolyline: false,
        drawRectangle: false,
        drawPolygon: false,
        editMode: false,
        dragMode: false,
        cutPolygon: false,
        drawText: false,
        removalMode: false,
        drawEllipse: false,
        rotateMode: false,
      },
    })
  }
  show(data?: any[]) {
    const list = data || this.data
    // 绘制航行警告 重要航警
    list.map((item: any, index: number) => {
      const pointsStr = item.points_conv
      const pointsArray = pointsStr.split(',')
      let coordinates: any[] = []
      const turfs: any[] = []

      let tipHtm = '<div class="nav_tooltip_content nav_tooltip_content_yj">'
      tipHtm += `<div class="nav_from ">信息来源：${item.source}</div>`
      tipHtm += `<div class="nav_title bd1">${item.type}：${item.title}</div>`
      tipHtm += `<div class="nav_content bd1">${item.content}</div>`
      tipHtm += `<div class="nav_time ">发布时间：${item.pub_time_conv}</div></div>`
      for (let i = 0; i < pointsArray.length; i += 2) {
        const { lat, lng } = CanvasShipUtils.GPSEncryptByMapToLatLng(
          L.latLng(
            Number.parseFloat(pointsArray[i]),
            Number.parseFloat(pointsArray[i + 1])
          ),
          this._map
        )
        coordinates.push([lng, lat])
        turfs.push(point([lng, lat]))
      }
      const features = featureCollection(turfs)

      const markerContent = center(features)
      coordinates = CanvasShipUtils.latlngsFrom180(coordinates)
      this.drawManager._DataEcho(item.layerId || index + 1, {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            style: {
              fillColor: '#FFFF00',
              dashArray: [5, 5],
              weight: 2,
              opacity: 0.5,
              color: '#FFF',
              fillOpacity: 0.4,
              // pane: 'tilePane',
              className: 'nav-svg',
            },
            properties: {
              name: '多边形绘制',
            },
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates],
            },
          },
          {
            ...markerContent,
            icon: L.icon({
              iconUrl: 'https://cdn.xplusship.com/img/images/navwarn.png',
              iconSize: [16, 16],
              shadowSize: [0, 0],
              iconAnchor: [8, 8],
              shadowAnchor: [0, 0],
              popupAnchor: [0, 0],
            }),
            showHtml: tipHtm,
            properties: {
              name: 'marker绘制区域',
            },
          },
        ],
      } as any)
      return coordinates
    })
  }
  hide(id?: string) {
    this.drawManager.remove(id)
  }
}
